export default __webpack_public_path__ + "static/media/logo.0e1e20e6.png";